export const header = [
  {
    id: 'id',
    label: '사용자 ID',
  },
  {
    id: 'name',
    label: '이름',
  },
  {
    id: 'admin',
    label: '행정동',
  },
  {
    id: 'department',
    label: '소속과',
  },
  {
    id: 'call',
    label: '연락처',
  },
  {
    id: 'date',
    label: '가입일',
  },
  {
    id: 'auth',
    label: '권한',
  },
];
